var _excluded = ["level", "childrenLoadLevel", "url", "dictType", "dictMap", "onChange", "value", "placeholder", "multiple", "autoRemoveDict", "delimiter", "type", "params", "autoClear", "readOnly", "disabled", "allowClear"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */

import { useField } from '@formily/react';
import { Select } from 'antd';
import cx from 'classnames';
import React from 'react';
import { useClear, useCssInJs, useDict, useParams, usePlaceholder, wrapReactionHook } from "../../hooks";
import { DictText } from "../DictText";
import { genDictSelectStyles } from "./styles";
export var DictSelect = wrapReactionHook(function (props) {
  var defaultPlaceholder = usePlaceholder();
  var _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    url = props.url,
    dictType = props.dictType,
    dictMap = props.dictMap,
    _onChange = props.onChange,
    value = props.value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? defaultPlaceholder : _props$placeholder,
    multiple = props.multiple,
    autoRemoveDict = props.autoRemoveDict,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? '、' : _props$delimiter,
    _props$type = props.type,
    type = _props$type === void 0 ? 'list' : _props$type,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    _props$autoClear = props.autoClear,
    autoClear = _props$autoClear === void 0 ? [] : _props$autoClear,
    readOnly = props.readOnly,
    disabled = props.disabled,
    _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'form-dict-select';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genDictSelectStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  var clear = useClear(autoClear);
  var getParams = useParams(params);
  var field = useField();
  var enums = field && field.dataSource;
  var dictParams = {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url,
    autoRemoveDict: autoRemoveDict,
    params: getParams(),
    dictMap: dictMap,
    enums: enums
  };
  var options = useDict(dictType, dictParams);
  if (readOnly) {
    return /*#__PURE__*/React.createElement(DictText, _extends({}, dictParams, {
      dictType: dictType,
      value: value
    }));
  }
  return wrapSSR( /*#__PURE__*/React.createElement(Select, _extends({
    className: cx(prefix, hashId),
    options: options,
    value: value,
    placeholder: placeholder,
    mode: multiple ? 'multiple' : undefined,
    popupMatchSelectWidth: false,
    onChange: function onChange(event) {
      clear();
      _onChange(event);
    },
    disabled: disabled,
    allowClear: allowClear && !disabled
  }, rest)));
});